import React, { useEffect, useState } from 'react'
import { Typography, Flex } from 'antd'
import {
  TransferHeader,
  TransferSection as StyledTransferSection,
  Content,
  SelectCount,
  ExpandButton,
} from './styled'
import { Transfer } from '@/shared/ui/components/Transfer'
import { TransferKey } from 'antd/es/transfer/interface'
import { Checkbox } from '@/shared/ui/components/Checkbox'
import { useBreakpoint } from '@/app/hooks/useBreakpoint'
import { Icon } from '@/shared/ui/Icon/Icon'
import { MessagePeriodSelect } from '../MessagePeriodSelect'
import { SYSTEM_TYPE, useSystemStore } from '@/app/store/systemStore'

const { Text } = Typography

interface TransferSectionProps {
  title: string
  dataSource: any[]
  value: TransferKey[]
  onChange: (targetKeys: TransferKey[]) => void
  onSelectAll: () => void
  onDeselectAll: () => void
  showMessagesBlock?: boolean
  showDriversBlock?: boolean
  loadMessages?: boolean
  loadDriversCodes?: boolean
  onLoadMessagesChange?: (checked: boolean) => void
  onLoadDriversCodesChange?: (checked: boolean) => void
  messagePeriod?: number
  onMessagePeriodChange?: (period: number) => void
  height?: number
  defaultOpen?: boolean
  disableCollapse?: boolean
  idField?: string
  nameField?: string
}

export const TransferSection: React.FC<TransferSectionProps> = ({
  title,
  dataSource,
  value,
  onChange,
  onSelectAll,
  onDeselectAll,
  showMessagesBlock = false,
  showDriversBlock = false,
  loadMessages = false,
  loadDriversCodes = false,
  onLoadMessagesChange,
  onLoadDriversCodesChange,
  messagePeriod = 30,
  onMessagePeriodChange,
  height = 354,
  defaultOpen,
  disableCollapse = false,
  idField = 'id',
  nameField = 'name',
}) => {
  const { isSm, isXs } = useBreakpoint()
  const isMobile = isXs || isSm

  const { selectedSystem } = useSystemStore()
  const isGS = selectedSystem === SYSTEM_TYPE.GLONASSOFT

  const isCollapseionEnabled = isMobile && !disableCollapse
  const [isOpen, setIsOpen] = useState<boolean>(
    !isCollapseionEnabled || (defaultOpen ?? title === 'Объекты')
  )

  useEffect(() => {
    if (!isCollapseionEnabled) {
      setIsOpen(true)
      return
    }
    setIsOpen(defaultOpen ?? title === 'Объекты')
  }, [isCollapseionEnabled, defaultOpen, title])

  const handleChange = (newValue: TransferKey[]) => {
    onChange(newValue)
  }

  const handleSelectAll = () => {
    onSelectAll()
  }

  const handleDeselectAll = () => {
    onDeselectAll()
  }

  return (
    <StyledTransferSection vertical gap={isMobile ? 16 : 8}>
      <TransferHeader
        justify="space-between"
        onClick={() => {
          if (isCollapseionEnabled) setIsOpen((prev) => !prev)
        }}
      >
        <Flex gap={4} align="center">
          <Text strong>{title}</Text>
          {isCollapseionEnabled && (
            <ExpandButton isOpen={isOpen}>
              <Icon name="expand_arrow" size={16} />
            </ExpandButton>
          )}
        </Flex>
        <SelectCount>Выбрано: {value.length}</SelectCount>{' '}
      </TransferHeader>
      {(!isCollapseionEnabled || isOpen) && (
        <Content vertical gap={24}>
          <Transfer
            dataSource={dataSource}
            value={value}
            onChange={handleChange}
            onSelectAll={handleSelectAll}
            onDeselectAll={handleDeselectAll}
            selectedCount={value.length}
            onSelectedCountChange={() => {}}
            idField={idField}
            nameField={nameField}
            listStyle={{
              width: '100%',
              height,
            }}
          />
          {showMessagesBlock && (
            <MessagePeriodSelect
              loadMessages={loadMessages}
              messagePeriod={messagePeriod}
              onMessagePeriodChange={onMessagePeriodChange}
              onLoadMessagesChange={onLoadMessagesChange}
            />
          )}
          {showDriversBlock && (
            <Checkbox
              checked={loadDriversCodes}
              onChange={(e) => onLoadDriversCodesChange?.(e.target.checked)}
            >
              <Text strong>
                Загружать {isGS ? 'карты-метки' : 'коды водителей'}
              </Text>
            </Checkbox>
          )}
        </Content>
      )}
    </StyledTransferSection>
  )
}
